/**
 * Centralized API configuration.
 *
 * Supports multiple deployment environments by checking common env keys.
 * In development it still defaults to localhost when no override is provided.
 */
const normalizeUrl = (value) => (typeof value === 'string' ? value.trim().replace(/\/+$/, '') : '');

const pickFirstUrl = (...values) => {
  for (const value of values) {
    const normalized = normalizeUrl(value);
    if (normalized) {
      return normalized;
    }
  }
  return '';
};

const DEV_API_BASE_URL = pickFirstUrl(
  process.env.REACT_APP_LOCAL_API_BASE_URL,
  process.env.REACT_APP_API_BASE_URL,
  process.env.REACT_APP_API_URL,
) || 'http://localhost:5000';

const PROD_API_BASE_URL = pickFirstUrl(
  process.env.VERCELAPP_API_BASE_URL,
  process.env.REACT_APP_API_BASE_URL,
  process.env.REACT_APP_API_URL,
  process.env.API_BASE_URL,
);

const DEFAULT_PROD_API_BASE_URL = 'https://api.laborconnect.app';

const SAME_ORIGIN_FALLBACK = (() => {
  if (typeof window === 'undefined' || !window.location?.origin) {
    return '';
  }
  return normalizeUrl(window.location.origin);
})();

export const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? (PROD_API_BASE_URL || SAME_ORIGIN_FALLBACK || DEFAULT_PROD_API_BASE_URL)
  : DEV_API_BASE_URL;

export const TURNSTILE_SITE_KEY = (process.env.REACT_APP_TURNSTILE_SITE_KEY || '').trim();

if (process.env.NODE_ENV === 'production' && !API_BASE_URL) {
  console.warn('API base URL is empty in production. Set VERCELAPP_API_BASE_URL, REACT_APP_API_BASE_URL, or REACT_APP_API_URL.');
}
